// extracted by mini-css-extract-plugin
module.exports = {"drawer":"drawer_sfoni","disableClick":"disableClick_alat6"};